import React, { Component } from 'react';
import styled from 'styled-components'
import { Button, Card, Divider, Input, Form } from 'antd'
import { apiUtil as Util } from '../../mock/mockServices';

const formItemLayout = {
  labelCol: {
    span: 4
  },
  wrapperCol: {
    span: 20
  }
};

let params = new URLSearchParams(window.location.search);
let orgId = params.get('id');

class OrgMgrComponent extends Component {

  state = {
    id: orgId,
    name: '',
    sName: '',
    code: '',
    type: '',
    mainBusiness: '',
    industry: '',
    country: '',
    province: '',
    city: '',
    district: '',
    address: '',
    contactPerson: '',
    contactMobile: '',
    contactPhone: '',
    contactEmail: '',
  }

  componentDidMount() {
    if (orgId !== "0") {
      Util.ajax.get('/admin/getOrgInfoById', {
        id: orgId
      }).then(res => {
        const { data } = res
        if (!data) {
          return false
        }
        const { name, sName, code, type, mainBusiness, industry, country, 
          province, city, district, address, contactPerson, contactMobile, contactPhone, contactEmail } = data

        this.setState({
          id: orgId,
          name: name ? name.value : '',
          sName: sName ? sName.value : '',
          code: code ? code.value : '',
          type: type ? type.value : '',
          mainBusiness: mainBusiness ? mainBusiness.value : '',
          industry: industry ? industry.value : '',
          country: country ? country.value : '',
          province: province ? province.value : '',
          city: city ? city.value : '',
          district: district ? district.value : '',
          address: address ? address.value : '',
          contactPerson: contactPerson ? contactPerson.value : '',
          contactMobile: contactMobile ? contactMobile.value : '',
          contactPhone: contactPhone ? contactPhone.value : '',
          contactEmail: contactEmail ? contactEmail.value : '',
        })
      })
    }
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, value) => {
      if (!err) {
        // console.log('Received values of form: ', value);
        if (orgId !== "0"){
          Util.ajax.post('/admin/createOrg', value).then(res => {
            Util.message.success('保存成功')
          })
        } else {
          Util.ajax.post('/admin/editOrg', value).then(res => {
            Util.message.success('保存成功')
          })
        }
      }
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Form layout="horizontal" {...formItemLayout} style={{ width: '660px' }} onSubmit={this.handleOk}>
        <Form.Item label="Name">
          {getFieldDecorator('name', {
            initialValue: this.state.name,
            rules: [
              { required: true, message: 'Please enter the organization name', whitespace: true },
            ]
          })(<Input />)}
        </Form.Item>
        <Form.Item label="Short Name">
          {getFieldDecorator('sName', {
            initialValue: this.state.sName,
            rules: [
              { required: true, message: 'Please enter the short name', whitespace: true },
            ]
          })(<Input />)}
        </Form.Item>
        <Form.Item label="Organization Code">
          {getFieldDecorator('code', {
            initialValue: this.state.code,
            rules: [
              { required: true, message: 'Please enter the organization code', whitespace: true },
            ]
          })(<Input />)}
        </Form.Item>
        <Form.Item label="Organization Type">
          {getFieldDecorator('type', {
            initialValue: this.state.type,
            rules: [
              { required: true, message: 'Please enter the organization type', whitespace: true },
            ]
          })(<Input />)}
        </Form.Item>
        <Form.Item label="Main Business">
          {getFieldDecorator('mainBusiness', {
            initialValue: this.state.mainBusiness,
            rules: [
              { required: true, message: 'Please enter the main business', whitespace: true },
            ]
          })(<Input />)}
        </Form.Item>
        <Form.Item label="Industry">
          {getFieldDecorator('industry', {
            initialValue: this.state.industry,
            rules: [
              { required: true, message: 'Please enter the industry', whitespace: true },
            ]
          })(<Input />)}
        </Form.Item>
        <Form.Item label="Country">
          {getFieldDecorator('country', {
            initialValue: this.state.country,
            rules: [
              { required: true, message: 'Please enter the country', whitespace: true },
            ]
          })(<Input />)}
        </Form.Item>
        <Form.Item label="Province/State">
          {getFieldDecorator('province', {
            initialValue: this.state.province,
            rules: [
              { required: true, message: 'Please enter the province or state', whitespace: true },
            ]
          })(<Input />)}
        </Form.Item>
        <Form.Item label="City">
          {getFieldDecorator('city', {
            initialValue: this.state.city,
            rules: [
              { required: true, message: 'Please enter the city', whitespace: true },
            ]
          })(<Input />)}
        </Form.Item>
        <Form.Item label="District/County">
          {getFieldDecorator('district', {
            initialValue: this.state.district,
            rules: [
              { required: true, message: 'Please enter the district or county', whitespace: true },
            ]
          })(<Input />)}
        </Form.Item>
        <Form.Item label="Address">
          {getFieldDecorator('address', {
            initialValue: this.state.address,
            rules: [
              { required: true, message: 'Please enter the detailed address', whitespace: true },
            ]
          })(<Input />)}
        </Form.Item>
        <Form.Item label="Contact Person">
          {getFieldDecorator('contactPerson', {
            initialValue: this.state.contactPerson,
            rules: [
              { required: true, message: 'Please enter the contact person', whitespace: true },
            ]
          })(<Input />)}
        </Form.Item>
        <Form.Item label="Contact Mobile">
          {getFieldDecorator('contactMobile', {
            initialValue: this.state.contactMobile,
            rules: [
              { required: true, message: 'Please enter the contact mobile', whitespace: true },
            ]
          })(<Input />)}
        </Form.Item>
        <Form.Item label="Contact Phone">
          {getFieldDecorator('contactPhone', {
            initialValue: this.state.contactPhone,
            rules: [
              { required: true, message: 'Please enter the contact phone', whitespace: true },
            ]
          })(<Input />)}
        </Form.Item>
        <Form.Item label="Contact Email">
          {getFieldDecorator('contactEmail', {
            initialValue: this.state.contactEmail,
            rules: [
              { required: true, message: 'Please enter the contact email', whitespace: true },
            ]
          })(<Input />)}
        </Form.Item>
        <Form.Item label="" wrapperCol={{ push: 4 }}>
          <Button className="mr20" onClick={this.handleTest}>Clear</Button>
          <Button type="primary" onClick={this.handleSubmit}>Save</Button>
        </Form.Item>
      </Form>
    )
  }
}

const OrgMgrForm = Form.create({ name: 'org-mgr-form' })(OrgMgrComponent)

export default class OrgMgr extends Component {

  render() {
    const isNew = orgId === "0";
    return (
      <Root>
        <div className="page-content">
          <Card title={
            <div style={{ fontSize: '22px', fontWeight: 'bold' }}>Organization Management</div>
          } bordered={false} style={{ width: '100%' }}>
            {/* <div className="title"></div>
                        <Divider></Divider> */}
            <div className="sub-title">
              {isNew ? (
                <div>Add New Organization</div>
              ) : (
                <div>Edit Organization (id: {orgId})</div>
              )}
            </div>
            <Divider></Divider>
            <OrgMgrForm></OrgMgrForm>
          </Card>
        </div>
      </Root>
    )
  }
}

const Root = styled.div`
    .title{
        font-size: 22px;
        font-weight: bold;
    }
    .sub-title{
        font-size:18px;
        font-weight: bold;
        padding: 5px 0 15px;
    }
`
